import { LoadState } from "../../../constants/enums";

export interface IBalanceSheetStatementsState {
  list: IBalanceSheetStatement[];
  loading: LoadState;
  totalRecords: number;
}

export interface IBalanceSheetStatement {

}


export const initialBalanceSheetStatementState: IBalanceSheetStatementsState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}